import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import bemify from 'bemify-js';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import DropdownMenu from 'web-ssr/app/common/components/DropdownMenu';
import { MenuSection } from 'web-ssr/app/common/components/Menu';
import 'web-ssr/app/common/components/AccountDropdown/AccountDropdown.scss';

const bem = bemify('account-dropdown');

const devpath = `developer/builder`;

const AccountDropdown = createReactClass({
  displayName: 'AccountDropdown',
  mixins: [PureRenderMixin],

  propTypes: {
    isDeveloper: PropTypes.bool.isRequired,
    onChoose: PropTypes.func,
    onClickOutside: PropTypes.func,
  },

  render() {
    const { ...props } = this.props;
    const navItems = [
      {
        href: '/app/settings',
        icon: 'cog-gear',
        label: 'Settings',
      },
      {
        href: props.isDeveloper ? `/${devpath}` : '/developer',
        icon: 'test',
        label: 'Developers',
      },
      {
        href: '/logout',
        icon: 'power',
        label: 'Log out',
      },
    ];
    return (
      <DropdownMenu
        className={bem()}
        kind="below justify-right block"
        onClickOutside={props.onClickOutside}
      >
        <MenuSection items={navItems} />
      </DropdownMenu>
    );
  },
});

export default AccountDropdown;
